/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Type_LabelInputs */

const en_preset_manager_type_label = /** @type {(inputs: Preset_Manager_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type:`)
};

const fr_preset_manager_type_label = /** @type {(inputs: Preset_Manager_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type :`)
};

const de_preset_manager_type_label = /** @type {(inputs: Preset_Manager_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ:`)
};

const it_preset_manager_type_label = /** @type {(inputs: Preset_Manager_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo:`)
};

const ru_preset_manager_type_label = /** @type {(inputs: Preset_Manager_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип:`)
};

const es_preset_manager_type_label = /** @type {(inputs: Preset_Manager_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo:`)
};

const zh_cn2_preset_manager_type_label = /** @type {(inputs: Preset_Manager_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`类型：`)
};

const ja_preset_manager_type_label = /** @type {(inputs: Preset_Manager_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイプ：`)
};

const hi_preset_manager_type_label = /** @type {(inputs: Preset_Manager_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रकार:`)
};

const pt_pt2_preset_manager_type_label = /** @type {(inputs: Preset_Manager_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo:`)
};

/**
* | output |
* | --- |
* | "Type:" |
*
* @param {Preset_Manager_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_type_label = /** @type {((inputs?: Preset_Manager_Type_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Type_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preset_manager_type_label(inputs)
	if (locale === "de") return de_preset_manager_type_label(inputs)
	if (locale === "it") return it_preset_manager_type_label(inputs)
	if (locale === "ru") return ru_preset_manager_type_label(inputs)
	if (locale === "es") return es_preset_manager_type_label(inputs)
	if (locale === "zh-CN") return zh_cn2_preset_manager_type_label(inputs)
	if (locale === "ja") return ja_preset_manager_type_label(inputs)
	if (locale === "hi") return hi_preset_manager_type_label(inputs)
	if (locale === "pt-PT") return pt_pt2_preset_manager_type_label(inputs)
	return en_preset_manager_type_label(inputs)
});